export const CurbsideOptions = [
  {
    name: "Regulatory Sign",
    imageSrc: "https://maps.google.com/mapfiles/ms/icons/green-dot.png"
  },
  // {
  //   name: "Traffic Sign",
  //   imageSrc: "https://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
  // },
  // {
  //   name: "Directional Sign",
  //   imageSrc: "https://maps.google.com/mapfiles/ms/icons/purple-dot.png"
  // },
  // {
  //   name: "Problematic Sign",
  //   imageSrc: "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
  // }
];

export const VehicleTypeOptions = {
  REGULAR: 'Regular',
  HANDICAP: 'Handicap',
  LOADING: 'Loading/Delivery',
};

export const PaymentTypeOptions = {
  FREE: 'Free',
  PAID: 'Paid',
  FREE_AND_PAID: 'Both (Free&Paid)',
};

export const SupportedCities = {
  BELLEVUE: 'Bellevue',
  MONTREAL: 'Montreal'
}

export const ZoneColors = {
  FREE: '#008000', // Free parking, green
  NO_PARKING: '#FF0000', // No parking, red
  LOADING: '#FFA500', // Loading zones, orange
  HANDICAP: '#0000FF', // Handicap parking, blue
  PAY_PARKING: '#0047AB', // Pay parking, deep blue
  BUS: '#800000', // Bus zones, maroon
  PASSENGER: '#800080', // Passenger loading, purple
  TRANSIT: '#008080', // Transit lanes, teal,
  UNREGULATED: '#696969' // When no info, gray
}

export const SupportedZoneTypes = {
  FREE: {
    value: 'free',
    color: '#32CD32' //bright green
  },
  PAY: {
    value: 'pay',
    color: '#4682B4' // blue
  },
  HANDICAP: {
    value: 'handicap',
    color: '#0000FF' // blue
  },
  NO_PARKING: {
    value: 'no_parking',
    color: '#FF0000' // red
  },
  NO_PARKING_FILL: {
    value: 'NP_refill',
    color: '#FF0000' // red
  },
  LOADING: {
    value: 'load',
    color: '#FFA500' // orange
  },
  BUS: {
    value: 'bus',
    color: '#00bfff' // light blue
  },
  PASSENGER: {
    value: 'passenger',
    color: '#008080' // teal
  },
  TRANSIT: {
    value: 'transit',
    color: '#6a329f' // purple
  },
  CROSSWALK: {
    value: 'crosswalk',
    color: '#de37d0' // pink
  },
  DRIVEWAY: {
    value: 'driveway',
    color: 'yellow'
  },
  EV: {
    value: 'Electric Vehicles',
    color: 'yellow'
  },
  SHUTTLE_STOP: {
    value: 'Shuttle Stop',
    color: '#FF69B4' // pink
  },
  UNREGULATED: {
    value: '',
    color: 'black' // gray
  },
  CROSSING: {
    value: 'crossing',
    color: '#FF0000'
  },
  ENTRANCE: {
    value: 'entrance',
    color: '#FF0000'
  }

}

export const AdditionalZoneOptions = {
  NO_PARKING: 'No Parking',
  DRIVEWAY: 'Driveway',
  BUS_STOP: 'Bus Stop',
  TRANSIT_ONLY: 'Transit Only',
  CROSSWALK: 'Crosswalk',
  PASSENGER: 'Passenger'
};